import { v4 as uuidv4 } from 'uuid';

export function getGuestId() {
  let guestId = localStorage.getItem('permit_guestId');

  if (!guestId) {
    guestId = 'permit_guest_' + uuidv4();
    localStorage.setItem('permit_guestId', guestId);
  }

  return guestId;
}
